import(/* webpackMode: "eager" */ "/mom-baby-web/src/app/global-error.tsx");
